import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns passengers object from form state
 */
export default function usePassengers() {
    return useAppSelector((state) => state?.form.passengers)
}